function initSettingsModal() {
  if (typeof MicroModal === "undefined") {
    return;
  }

  MicroModal.init({
    openTrigger: "data-micromodal-trigger",
    closeTrigger: "data-micromodal-close",
    disableScroll: true,
    awaitOpenAnimation: true,
    awaitCloseAnimation: true,
    debugMode: false,
  });

  // Auto-open modal if redirected back after a form submission
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("update")) {
    const modal = document.getElementById("tbp-settings-modal");
    if (modal) {
      MicroModal.show("tbp-settings-modal");
    }
  }
}

function initUserDashboard() {
  const userDashboard = document.querySelector(".js-tbp-user-dashboard");

  if (!userDashboard) {
    return;
  }

  // Set up edit buttons
  const formEditButtons = document.querySelectorAll(
    ".js-tbp-user-form-edit-button",
  );

  formEditButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      const parentField = button.closest(".tbp-user-form__field");
      const input = parentField.querySelector("input");

      if (input.disabled == false) {
        input.disabled = true;
      } else {
        input.disabled = false;
      }
    });
  });

  // Handle form submission
  const userForm = userDashboard.querySelector(".tbp-user-form");
  if (!userForm) {
    return;
  }

  userForm.addEventListener("submit", (e) => {
    e.preventDefault();

    // Enable inputs for submission otherwise nothing is sent
    const inputFields = userForm.querySelectorAll("input");
    inputFields.forEach((input) => {
      input.disabled = false;
    });
    userForm.submit();
  });
}

initUserDashboard();
initSettingsModal();
